import styled from "styled-components";

import theme from "config/theme";

import { H5 } from "components/Text";
import { Block } from "components/Grid";

export const Wrapper = styled(Block)`
  align-self: flex-start;
  text-align: center;
`;

export const Icon = styled.img`
  width: 60px;
  height: 60px;
  margin: 0 auto 25px;

  @media (max-width: ${theme.size.mobile}) {
    width: 50px;
    height: 50px;
    margin-bottom: 20px;
  }
`;

export const Heading = styled(H5)`
  line-height: 1.4;
  margin-bottom: 0;
  width: 100%;
  color: ${props => (props.shade === "light" ? "white" : theme.color.gray)};
`;

export const Text = styled.p`
  width: 100%;
  margin-top: 15px;
  font-size: ${theme.font.size.epsilon};
  color: ${props =>
    props.shade === "light" ? theme.color.paper2 : theme.color.gray2};
`;
